module.exports = __webpack_public_path__ + "static/media/ic_verfication_in_progress.435a1c84.gif";